module.exports = __webpack_public_path__ + "static/img/mingshiicon1.c011e2f4.png";